var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { attrs: { id: "menu_container" } },
    [
      _c("EMapMenu", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selected_main_menu === "emap",
            expression: "selected_main_menu==='emap'"
          }
        ],
        on: {
          "transfer-information": function(information) {
            return _vm.$emit("transfer-information", information)
          }
        }
      }),
      _vm._v(" "),
      _vm.atlas_loaded
        ? _c("AtlasMenu", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selected_main_menu === "atlas",
                expression: "selected_main_menu === 'atlas'"
              }
            ],
            attrs: { atlas_menu_data: _vm.atlas_menu_data }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.monitor_loaded
        ? _c("MonitorMenu", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selected_main_menu === "monitor",
                expression: "selected_main_menu === 'monitor'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Account", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selected_main_menu === "account",
            expression: "selected_main_menu === 'account'"
          }
        ]
      }),
      _vm._v(" "),
      _c("LanguageSetting", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selected_main_menu === "language_setting",
            expression: "selected_main_menu === 'language_setting'"
          }
        ]
      }),
      _vm._v(" "),
      _c("About", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selected_main_menu === "about",
            expression: "selected_main_menu === 'about'"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }